import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

import { ToItineraryDateModule } from '@hiptraveler/features/itinerary';

import { ActivityDateComponent } from './activity-date.component';
import { DayColorBorderPipe } from './day-color-border.pipe';

const MODULES = [
  CommonModule,
  MatRippleModule,
  MatIconModule,
  MatButtonModule,
  MatProgressSpinnerModule,
  TranslateModule
];

const LIBRARIES = [
  ToItineraryDateModule
];

const COMPONENTS = [
  ActivityDateComponent,
  DayColorBorderPipe
];

@NgModule({
  imports: [
    MODULES,
    LIBRARIES
  ],
  declarations: [
    COMPONENTS
  ],
  exports: [
    ActivityDateComponent
  ]
})
export class ActivityDateModule { }
